var _rect, _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 69,
    viewBox: "0 0 68 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.695312,
    width: 68,
    height: 68,
    rx: 16,
    fill: "#F4F8FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 22.2969,
    r: 11,
    fill: "#FFDFB3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.0019,
    cy: 22.2943,
    r: 8.25,
    transform: "rotate(0.5 34.0019 22.2943)",
    fill: "#FFBF66"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 22.3008,
    r: 5.5,
    fill: "#FFAA33"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 28.0215C12 25.8123 13.7909 24.0215 16 24.0215H52C54.2091 24.0215 56 25.8123 56 28.0215V44.1882H12V28.0215Z",
    fill: "#E6F2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 44.1855H56V44.819C56 47.0281 54.2091 48.819 52 48.819H16C13.7909 48.819 12 47.0281 12 44.819V44.1855Z",
    fill: "#B3D7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9414 58.0918H47.061V57.4583C47.061 55.2492 45.2702 53.4583 43.061 53.4583H24.9414C22.7323 53.4583 20.9414 55.2492 20.9414 57.4583V58.0918Z",
    fill: "#66AFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 48.8223H39.5V53.4557H28.5V48.8223Z",
    fill: "#3395FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 26.5547,
    width: 12,
    height: 4.12109,
    rx: 1,
    fill: "#66AFFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 26.5547,
    width: 12,
    height: 4.12109,
    rx: 1,
    fill: "#66AFFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 26.5547,
    width: 12,
    height: 4.12109,
    rx: 1,
    fill: "#66AFFF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 32.0391,
    width: 12,
    height: 4.12109,
    rx: 1,
    fill: "#66AFFF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 32.0391,
    width: 12,
    height: 4.12109,
    rx: 1,
    fill: "#66AFFF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 32.0391,
    width: 12,
    height: 4.12109,
    rx: 1,
    fill: "#66AFFF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 37.5391,
    width: 12,
    height: 4.12109,
    rx: 1,
    fill: "#66AFFF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 37.5391,
    width: 12,
    height: 4.12109,
    rx: 1,
    fill: "#66AFFF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 37.5391,
    width: 12,
    height: 4.12109,
    rx: 1,
    fill: "#66AFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergy);
export default __webpack_public_path__ + "static/media/energy.82a045c253e254cc8c291dd5fef462a6.svg";
export { ForwardRef as ReactComponent };